import { jsx as r } from "react/jsx-runtime";
import { B as e } from "../Badge-BvOr_qSw.js";
import { c as o } from "../clsx-OuTLNxxd.js";
import { c as u } from "../index-DpeO8ABv.js";
import { C as i } from "../Cross-DkElekIV.js";
import { C as n } from "../Check-Cw4qhL84.js";
import "../Status.css?__remix_sideEffect__";const m = "_status_zv215_1",l = "_success_zv215_5",a = {
    status: m,
    success: l
  },p = u(a.status, {
    variants: {
      status: {
        success: a.success,
        error: a.error
      }
    },
    defaultVariants: {
      status: "success"
    }
  }),V = ({
    status: s,
    className: t,
    ...c
  }) => /* @__PURE__ */r(
    e,
    {
      isRound: !0,
      variant: {
        success: "primary",
        error: "error"
      }[s || "success"],
      size: "l",
      className: o(p({ status: s }), t),
      "aria-label": `${s}-badge`,
      ...c,
      children: s == "success" ? /* @__PURE__ */r(n, {}) : /* @__PURE__ */r(i, {})
    }
  );
export {
  V as Status };